document.addEventListener(
  "DOMContentLoaded",
  () => {
    // header nav
    const body = document.querySelector("body");
    const navtogglecheckbox = document.getElementById("nav-toggle-checkbox");

    if (navtogglecheckbox) {
      navtogglecheckbox.addEventListener("click", (e) => {
        if (!navtogglecheckbox.checked) document.activeElement.blur();
      });
      body.addEventListener("click", (e) => {
        if (!document.activeElement.classList.contains("nav-toggle-menu"))
          navtogglecheckbox.checked = false;
      });
    }

    // current page link
    const path = window.location.pathname;
    const anchors = document.querySelectorAll("header ul.menu li a");
    anchors.forEach(function (anchor) {
      let href = anchor.getAttribute("href");
      if (path == href) anchor.classList.add("bg-primary");
    });

    // totop
    const scrolltotopbtn = document.querySelector("#scroll-to-top-btn");
    if (scrolltotopbtn) {
      scrolltotopbtn.addEventListener("click", () => {
        window.scroll({ top: 0, behavior: "smooth" });
      });
    }

    // footer lang
    const langBtnJp = document.getElementById("lang-btn-jp");
    langBtnJp.href = window.location.pathname.replace("/en/", "/jp/");
    const langBtnEn = document.getElementById("lang-btn-en");
    langBtnEn.href = window.location.pathname.replace("/jp/", "/en/");

    // tab
    let tabsContainer = document.querySelector("#tabs-container");
    if (tabsContainer) {
      let tabTogglers = tabsContainer.querySelectorAll(".tabs .tab");

      tabTogglers.forEach(function (toggler) {
        toggler.addEventListener("click", function (e) {
          e.preventDefault();
          let tabName = this.getAttribute("data-tab-name");
          let tabContents = tabsContainer.querySelector(".tabs-contents");
          for (let i = 0; i < tabContents.children.length; i++) {
            tabTogglers[i].classList.remove("tab-active");
            if (
              tabContents.children[i].getAttribute("data-tab-name") === tabName
            ) {
              tabContents.children[i].classList.remove("hidden");
            } else {
              tabContents.children[i].classList.add("hidden");
            }
          }
          e.target.classList.add("tab-active");
        });
      });
    }
  },
  false
);
